// extracted by mini-css-extract-plugin
export default {"success":"ModalSuccess_success__2n0i8","text":"ModalSuccess_text__gQV3v","wrappImg":"ModalSuccess_wrappImg__0Ssls"};